import { gql } from '@apollo/client';

export const CREATE_NOTIFICATION = gql`
    mutation createNotification($input: CreateNotificationInput!) {
        createNotification(input: $input) {
            id
            verb
            actor
            recipient
            targetObjectId
            targetObjectType
            message
            actionObjectType
            actionObjectId
            read
            creator
            created
            updater
            updated
        }
    }
`;
